import { render, staticRenderFns } from "./DeckList.vue?vue&type=template&id=6cead230&scoped=true&"
import script from "./DeckList.vue?vue&type=script&lang=js&"
export * from "./DeckList.vue?vue&type=script&lang=js&"
import style0 from "./DeckList.vue?vue&type=style&index=0&id=6cead230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cead230",
  null
  
)

export default component.exports